import type { FaireProductEntity } from "../../entity_types/product";

export const p_nkj3skru43: FaireProductEntity = {
  token: "p_nkj3skru43",
  type: "product",
  name: "Smiley Tissue Paper",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/15a8a2d865e263902f92b0b2b4e4bebd14162ecffcd17e614c529a7f41f0acf1.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1b6abfcad1185fc2387337a52bf65728530ccb7f6e08603e46f2d29cbcfbd961.png",
    "https://cdn.faire.com/fastly/9a6448e03aea37fcbe46e8428fdc66c8e7596f4201eea2e46a0b78c9632f5ed5.png",
  ],
  priceDollars: 4,
  description:
    "Each package contains 10 generously sized sheets of tissue paper to mix and match with our coordinating gift bags (sold separately). The weirdly best part—unused tissue easily slides back into the envelope for organized storage, no more loose, crinkled foldy piles!",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:39.257Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
